import {
  LightbulbOutlined,
  CancelOutlined,
  Person,
  PeopleAlt,
  AccountBoxOutlined,
  ChevronRightOutlined,
  SubdirectoryArrowRightOutlined,
  MenuOutlined,
  ControlPointRounded
} from '@mui/icons-material';
import BoltIcon from '@mui/icons-material/Bolt';
import { styled, Paper, Button as MaterialButton, Stack, Badge, MenuItem, Grid } from '@mui/material';

import { Button } from '../../../../../components/atoms/Button';
import { SelectMenu } from '../../../../../components/atoms/SelectMenu';
import { TextField } from '../../../../../components/atoms/TextField';
import { Typography } from '../../../../../components/atoms/Typography';
import { COLORS } from '../../../../../configs/colors';

export const ContentPaper = styled(Paper)`
  padding: 10px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: whitesmoke;
`;

export const ActionBarStack = styled(Stack)((props: { isStatusChange: boolean }) => `
  min-height: 44px;
  margin-top: ${props.isStatusChange ? '-15px' : '-15px'};
`);

export const IconContainer = styled('div')((props: { backgroundColor: string }) => `
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background-color: ${props.backgroundColor};
  margin-right: 10px;
  margin-top: 5px;
`);

export const StatusbarHeadingText = styled(Typography)`
  font-size: 15px;
  color: ${COLORS.LightNavyBlue};
`;

export const NewButton = styled(Button)((props: { isMobile: boolean }) =>`
  flex: 1;
  height: 40px;
  font-size: ${props.isMobile ? '15px' : '18px'};
  text-transform: capitalize;
  border: none;
  color: ${COLORS.NavyBlue};
  justify-content: left;
  padding-left: ${props.isMobile ? 'auto' : '20px'};

  & .MuiSvgIcon-root {
    font-size: ${props.isMobile ? '20px' : '24px'};
  }
`);

export const SubmitButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: whitesmoke!important;
`;

export const CloseStatusChangeButton = styled(Button)`
  font-size: 18px;
  text-transform: capitalize;
  border-color: whitesmoke !important;
  color: ${COLORS.Orange};
`;

export const LightbulbIcon = styled(LightbulbOutlined)`
  color: ${COLORS.NavyBlue};
`;

export const CancelIcon = styled(CancelOutlined)`
  color: ${COLORS.Orange};
`;

export const PrimaryAllocationIcon = styled(Person)`
  color: ${COLORS.NavyBlue};
`;

export const SecondaryAllocationIcon = styled(PeopleAlt)`
  color: ${COLORS.NavyBlue};
`;

export const AccountIcon = styled(AccountBoxOutlined)`
  color: ${COLORS.Blue};
`;

export const ForwardIcon = styled(ChevronRightOutlined)`
  color: gray;
`;

export const MenuIcon = styled(MenuOutlined)`
  font-size: 32px;
  color: gray;
`;

export const ControlPointRoundedIcon = styled(ControlPointRounded)`
  font-size: 32px;
  color: dark-gray;
`;

export const MenuButton = styled(MaterialButton)`
  margin-right: -20px!important;
  color: gray;
`;

export const SubdirectoryArrowIcon = styled(SubdirectoryArrowRightOutlined)`
  color: #7B1FA2;
`;

export const LocationText = styled(Typography)((props: { isMobile: boolean }) =>`
  font-size: ${props.isMobile ? '14px' : '18px'};
  font-weight: 500;
  color: ${COLORS.NavyBlue};
`);

export const LocationSubText = styled(Typography)((props: { isMobile: boolean }) =>`
  font-size: ${props.isMobile ? '13px' : '18px'};
  font-weight: 400;
  color: ${COLORS.LightNavyBlue};
`);

export const AccountText = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  color: ${COLORS.Blue};
`;

export const SuggestedText = styled(Typography)`
  font-size: 10px;
  font-weight: 500;
  color: gray;
`;

export const NotesText = styled(TextField)`
  flex-grow: 1;
`;

export const ClickableStack = styled(Stack)`
  flex: 1;
  cursor: pointer;
  border-radius: 8px;
  margin-left: 10px;
  &:hover {
    background-color: #EDEEEE;
  }
  transition: background-color 0.3s;
`;

export const AddButton = styled(Button)`
  height: 100%;
  min-height: 100px;
  width: 100%;
  min-width: 100%;
`;

export const CancelButton = styled(Button)`
  height: 40px;
  font-size: 18px;
  border-color: whitesmoke!important;
  color: ${COLORS.Orange};
`;

export const StyledSelectMenu = styled(SelectMenu)`
  width: 100%;
`;

export const FullWidthBadge = styled(Badge)`
  width: 100%;
`;

export const FullWidthBadgeInteraction = styled(Badge)`
  width: 110%;
`;

export const FullWidthMenuItem = styled(MenuItem)`
  width: 100%;
`;

export const StyledActionBarStack = styled('div')((props: { isMobile?: boolean }) =>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${props.isMobile &&
    `
      margin-top: 5px;
    `}
`);

export const SelectStatusContainer = styled(Stack)`
  width: 100%;
  margin-bottom: 20px;
`;

export const CloseIconWrapStack = styled(Stack)`
  margin-top: -20px;
  margin-left: 30px;
  width: 100%;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const ZapSquareIcon = styled(BoltIcon)`
  margin-right: 8px;
  border: 1px solid black;
  padding: 0px;
`;

export const CancelButtonWrapStack = styled(Stack)`
  margin-top: -10px;
  margin-left: 22px;
  margin-bottom: 15px;
  width: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  z-index: 100;
`;

export const StatusSaveButtonWrap = styled(Stack)`
  margin-left: 10px;
  justify-content: center;
`;

export const StatusbarItemGrid = styled(Grid)`
  display: flex;
  align-items: center;
  border-radius: 7.5px;
  box-shadow: ${props => props.theme.shadows[4]};
  &:hover {
    background-color: #eaececff;
  }
`;

export const StatusbarItemHeadingGrid= styled(Grid)`
  width: 90px;
  text-align: right;
`;

export const PartActionContainer = styled(Grid)((props: { isMobileView: boolean }) => `
  display: grid;
  row-gap: 4px;
  column-gap: 20px;
  margin-top: 8px;
  margin-left: -15px;
  
  ${!props.isMobileView && `
    grid-template-columns: repeat(2, minmax(500px, 1fr));
    @media (max-width: 1350px) {
      grid-template-columns: repeat(1, minmax(500px, 1fr));
    }
  `}
`);

export const PartActionCardWrapper = styled(Grid)`
  width: 100%;
`;